module.exports = __webpack_public_path__ + "img/a6.5ede27a1.svg";